import { render, staticRenderFns } from "./VoluntaryMedicalInsurance.vue?vue&type=template&id=14b071b3"
import script from "./VoluntaryMedicalInsurance.vue?vue&type=script&lang=ts"
export * from "./VoluntaryMedicalInsurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports